import { assetActions } from '@bvt-features/pertamina/store/asset/asset.slice';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDetailAsset,
  getListAsset,
  doDownloadAssetList,
  createUpdateAsset,
  doDeleteAsset,
  getRukoListDetail,
  getTenantListDetail,
  getPOIListDetail,
  getStatusAnalysisAsset,
  getKategoriList,
  removeNewTenant,
  createNewTenant,
  getNewTenantList,
  bulkDownloadResult,
  doDownloadBulkResultXls,
  getHistoryList,
  doDownloadBulkPDF,
} from '@bvt-features/pertamina/store/asset/asset.asyncAction';

export const usePertaminaAsset = () => {
  const state = useSelector((state) => state.features.PERTAMINA.asset);
  const dispatch = useDispatch();

  const resetState = () => dispatch(assetActions.resetState());

  /**
   *
   * @param {object} param
   * @param {'status_LIST_ASSET'|'status_DASHBOARD_RESULT'} param.type
   */
  const resetStatus = (param) =>
    dispatch(assetActions.resetStatus({ type: param.type }));

  const resetDashboard = () => dispatch(assetActions.resetDashboard());

  /**
   *
   * @param {object} param
   * @param {string} param.id
   */
  const setSelectedID = (param) => dispatch(assetActions.setSelectedID(param));

  /**
   *
   * @param {object} param
   * @param {string} param.img
   */
  const setSelectedImg = (param) =>
    dispatch(assetActions.setSelectedImg(param));

  /**
   *
   * @param {object} param
   * @param {object} param.coordinate
   * @param {string} param.coordinate.lat
   * @param {string} param.coordinate.lng
   */
  const setCoordinate = (param) => dispatch(assetActions.setCoordinate(param));

  const getListAssetPertamina = (param) => dispatch(getListAsset(param));

  const getDetailAssetPertamina = (param) => dispatch(getDetailAsset(param));

  const doDownloadAssetListPertamina = (param) =>
    dispatch(doDownloadAssetList(param));

  /**
   *
   * @param {boolean} param
   */
  const setStartDownload = (param) => {
    dispatch(assetActions.setStartDownload(param));
  };

  /**
   * @param {boolean} param
   */
  const setToggleStatus = (param) =>
    dispatch(assetActions.setToggleStatus(param));

  const resetDownload = () => dispatch(assetActions.resetDownload());

  /**
   * @param {object} params
   * @param {string} params.id
   * @param {string} params.lat
   * @param {string} params.long
   * @param {string} params.name
   * @param {string} params.address
   */
  const setEditData = (params) => dispatch(assetActions.setEditData(params));

  /**
   *
   * @param {object} param
   * @param {string} param.site_id
   * @param {string} param.name
   * @param {string} param.longitude
   * @param {string} param.latitude
   * @param {string} param.address
   */
  const addEditAsset = (param) => dispatch(createUpdateAsset(param));

  /**
   * @param {string} id
   */
  const deleteAsset = (id) => dispatch(doDeleteAsset(id));

  /**
   * @param {object} params
   * @param {string} params.area_ruko_id
   * @param {boolean} params.is_history
   * @param {string} params.period
   */
  const getRukoList = (params) => dispatch(getRukoListDetail(params));

  /**
   * @param {object} params
   * @param {string} params.area_tenant_id
   * @param {boolean} params.is_history
   * @param {string} params.period
   */
  const getTenantList = (params) => dispatch(getTenantListDetail(params));

  /**
   * @param {object} params
   * @param {string} params.area_poi_id
   * @param {boolean} params.is_history
   * @param {string} params.period
   */
  const getPOIList = (params) => dispatch(getPOIListDetail(params));

  const getStatusAnalysis = (param) => dispatch(getStatusAnalysisAsset(param));

  const getListKategori = () => dispatch(getKategoriList());

  const getNewTenants = () => dispatch(getNewTenantList());
  const deleteNewTenant = (id) => dispatch(removeNewTenant(id));
  const addNewTenant = (payload) => dispatch(createNewTenant(payload));

  /**
   * @param {object} param
   * @param {string} param.url
   * @param {string} param.filename
   * @param {string} param.status
   * @param {string} param.message
   */
  const doDownloadBulkResult = (param) => dispatch(bulkDownloadResult(param));

  /**
   * @param {boolean} param
   */
  const setShowDownload = (param) =>
    dispatch(assetActions.setShowDownload(param));

  const doBulkDownloadXls = (param) => dispatch(doDownloadBulkResultXls(param));

  /**
   * @param {boolean} param
   */
  const setLoadingDownload = (param) =>
    dispatch(assetActions.setLoadingDownload(param));

  /**
   * @param {string} param
   */
  const getHistoryLog = (param) => dispatch(getHistoryList(param));

  const doBulkDownloadPDF = (param) => dispatch(doDownloadBulkPDF(param));
  /**
   * @param {string} param
   */
  const setDownloadFilename = (param) =>
    dispatch(assetActions.setDownloadFilename(param));

  return {
    setDownloadFilename,
    doBulkDownloadPDF,
    getHistoryLog,
    getListKategori,
    getStatusAnalysis,
    getPOIList,
    getTenantList,
    getRukoList,
    setEditData,
    deleteAsset,
    resetDownload,
    setStartDownload,
    doDownloadAssetListPertamina,
    doDownloadBulkResult,
    getListAssetPertamina,
    resetState,
    resetDashboard,
    resetStatus,
    getDetailAssetPertamina,
    setSelectedID,
    setSelectedImg,
    setCoordinate,
    addEditAsset,
    setToggleStatus,
    deleteNewTenant,
    addNewTenant,
    getNewTenants,
    setShowDownload,
    doBulkDownloadXls,
    setLoadingDownload,
    state,
  };
};
